<template>
  <v-app light>
    <v-content>
      <v-container grid-list-md fill-height>
        <v-layout justify-center align-center>
          <v-flex xs12 sm8 md6 lg4>
            <v-card elevation="20">
              <v-card-title>
                <v-btn v-show="showPasswordField" icon @click="switchUsername()"
                  ><v-icon>navigate_before</v-icon></v-btn
                >
                <h3>LOGIN - REGISTRU</h3>
              </v-card-title>
              <v-card-text>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-text-field
                    v-model="username"
                    label="Username"
                    prepend-icon="person"
                    :rules="[rules.required]"
                    :readonly="showPasswordField"
                    @keydown="handleKeyDown"
                  />
                  <v-text-field
                    v-if="showPasswordField"
                    v-model="password"
                    :append-icon="showpass ? 'visibility' : 'visibility_off'"
                    :type="showpass ? 'text' : 'password'"
                    name="input-10-1"
                    prepend-icon="lock"
                    label="Parola"
                    :rules="[rules.required]"
                    @click:append="showpass = !showpass"
                    @keydown="handleKeyDown"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <span class="subtitle-2" style="color: red">{{
                  loginError
                }}</span>
                <v-spacer />
                <v-btn
                  color="primary"
                  :disabled="!valid"
                  :loading="loading"
                  @click="login()"
                  >Login</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import store from '../store'
import * as Msal from 'msal'
import Constants from '../constants'
export default {
  name: 'Login',
  data() {
    return {
      username: null,
      password: null,
      showpass: false,
      showPasswordField: false,
      rules: {
        required: (value) => {
          return !!value || 'Required!'
        }
      },
      valid: true,
      loginSucceeded: false,
      loading: false,
      loginError: null
    }
  },
  watch: {
    loginSucceeded(newVal) {
      if (newVal === true) {
        this.$router.push('/')
      }
    },
    loading(newVal) {
      if (newVal === true) {
        this.loginError = null
      }
    },
    username() {
      this.loginError = null
    },
    password() {
      this.loginError = null
    }
  },
  methods: {
    handleKeyDown(evt) {
      if (evt.keyCode === 13) {
        evt.preventDefault()
        this.login()
      }
    },
    switchUsername() {
      this.password = null
      this.showPasswordField = false
    },
    async login() {
      if (!this.$refs.form.validate()) return
      const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      // validate the form

      if (emailRegex.test(this.username)) {
        // microsoft login
        const config = {
          auth: {
            clientId: Constants.AZURE_AD_CLIENT_ID,
            authority: Constants.AZURE_AD_AUTHORITY
          }
        }
        const app = new Msal.UserAgentApplication(config)
        const accessTokenRequest = {
          scopes: ['user.read'],
          loginHint: this.username
        }
        try {
          this.loading = true
          const accessTokenResponse = await app.acquireTokenPopup(
            accessTokenRequest
          )
          store
            .dispatch(
              'loginMicrosoft',
              accessTokenResponse.accessToken.replace('Bearer ', '')
            )
            .then(() => {
              this.loading = false
              this.$router.push('/')
            })
            .catch((ex) => {
              this.loading = false
              if (ex.response.status === 401) {
                this.loginError = 'Invalid account!'
              } else if (ex.response.status === 500) {
                this.loginError = 'Server error!'
              } else {
                this.loginError = 'Unknown error!'
              }
              console.log('Could not login with microsoft account!')
              console.log(ex)
            })
        } catch (ex) {
          this.loading = false
          this.loginError = 'Connection error!'
          console.log('Could not acquire microsoft jwt')
          console.log(ex)
        }
      } else {
        if (this.showPasswordField) {
          this.loading = true
          store
            .dispatch('login', {
              username: this.username,
              password: this.password
            })
            .then(() => {
              this.loading = false
              this.$router.push('/')
            })
            .catch((ex) => {
              this.loading = false
              if (ex.response.status === 401) {
                this.loginError = 'Invalid account!'
              } else if (ex.response.status === 500) {
                this.loginError = 'Server error!'
              } else {
                this.loginError = 'Unknown error!'
              }
            })
        } else {
          this.showPasswordField = true
          this.$refs.form.resetValidation()
        }
      }
    }
  }
}
</script>

<style scoped>
h1 {
  font-size: 40px;
  margin-top: 10px;
}
div {
  padding-left: 10px;
  padding-right: 10px;
}
</style>
